import { SETCONFIG } from "../../actions/config/types";
import { getCookie } from "../../../services/CookieManager";
import jwt_decode from "jwt-decode";

const decodeConfigValue = (value) => {
  if (!value) return null;
  let decoded = value;
  try {
    decoded = JSON.parse(value);
  } catch (jsonErr) {
    try {
      decoded = jwt_decode(value);
    } catch {
      decoded = value;
    }
  }

  return decoded?.data ?? decoded;
};

let initialConfig = null;
try {
  const sourceValue = localStorage.getItem("config") || getCookie("config");
  if (sourceValue) {
    initialConfig = decodeConfigValue(sourceValue);
  }
} catch (error) {
  console.error("Error reading config from storage:", error);
}

const initialState = {
  config: initialConfig,
};

const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETCONFIG: {
      if (typeof action?.data === "undefined") {
        return state;
      }

      const decoded = decodeConfigValue(action.data);
      const valueToStore =
        typeof action.data === "string"
          ? action.data
          : JSON.stringify(action.data);

      try {
        localStorage.setItem("config", valueToStore);
      } catch (error) {
        console.error("Error saving config to localStorage:", error);
      }

      return { ...state, config: decoded };
    }
    default:
      return state;
  }
};

export default configReducer;
